<template>
  <pre_input :value="value" :label="label" :md="md" :tag="c_tag" :view_only="view_only">
    <div style="text-align: center;">
      <span class="label">
        {{label}}:<fs1-tooltip v-if="tooltp" :text="tooltp"/>
      </span>
      <ul class="statusFilter mt-2">
        <li
          v-for="(item, i) in items"
          :key="i"
          :style="model.find(i => i === item.value) ? `background-color:orange; color: black`: (`color:${dark_t?'white':'black'}`)"
          :class="model.find(i => i === item.value) && `selected`"
          @click="toggleItems(model, item.value)">
          {{item.name}}
        </li>
      </ul>
    </div>
  </pre_input>
</template>
<script>
import filter_rq from './filter_rq';
import pre_input_js from '@/components/mixins/pre_input';
export default {
  props:{
    tooltp:{},
    label:{default:''},
    items:{default:()=>{}},
    f_key:{},
  },
  mixins: [ filter_rq, pre_input_js ],
  data(){
    return {
      model: [],
      multiple: true,
      reset_on_value_change:true,
      filter_rq_type:['>'],
    }
  },
  computed: {
    k_f(){ return this.f_key },
    c_value_key() {return this.value_key || this.item_key},
  },
  created(){
    if (!this.value) this.model = this.items.map((e)=>e.value)
    else this.model = this.value || [];
  },
  methods: {
    toggleItems(items, item) {
      items.find(i => i === item) ? items.splice(items.indexOf(item), 1) : items.push(item);
      this.upd();
    },
    set_model() { this.model = this.value || [] },
    upd(){
      this.$emit('update:value', this.model);
      const ex_f = {};
      ex_f[this.k_f] = this.model;
      this.pre_get(ex_f,this.k_f);
      this.get_rq(ex_f);
    },
    then_get_rows(r) { return r },
  },
};
</script>
<style scoped>
  .statusFilter{
    list-style: none;
    padding: 0;
  }
  .statusFilter > li{
    text-decoration: line-through;
    cursor: pointer;
    border-radius: 3px;
    background-color: none;
    color: black;
    display: inline;
    padding: 4px 14px 4px 14px;
    margin-right: 5px;
  }
  .statusFilter > li.selected{
    color: white;
    text-decoration: none;
  }
</style>